import { render, staticRenderFns } from "./OnePageLayout.vue?vue&type=template&id=0abf93eb&"
import script from "./OnePageLayout.vue?vue&type=script&lang=js&"
export * from "./OnePageLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports